import { DragDropModule } from "@angular/cdk/drag-drop";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { IMaskModule } from "angular-imask";
import { PessoaModule, SharedModule } from "eddydata-lib";
import { AccordionModule } from "primeng/accordion";
import { MessageService } from "primeng/api";
import { AutoCompleteModule } from "primeng/autocomplete";
import { ButtonModule } from "primeng/button";
import { CalendarModule } from "primeng/calendar";
import { CheckboxModule } from "primeng/checkbox";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { DialogModule } from "primeng/dialog";
import { FieldsetModule } from "primeng/fieldset";
import { FileUploadModule } from "primeng/fileupload";
import { RadioButtonModule } from "primeng/radiobutton";
import { SelectButtonModule } from "primeng/selectbutton";
import { ToastModule } from "primeng/toast";
import { ToggleButtonModule } from "primeng/togglebutton";
import { TooltipModule } from "primeng/tooltip";
import { PanelModule } from "primeng/panel";
import { InputMaskModule } from "primeng/inputmask";
import { MenuModule } from "primeng/menu";
import { RelatorioItensMovimentadosRptComponent } from "./itens-movimentados-rpt/itens-movimentados-rpt.component";
import { RelatorioPosicaoEstoqueRptComponent } from "./relatorio-posicao-estoque-rpt/relatorio-posicao-estoque-rpt.component";
import { RelatorioSaidaRptComponent } from "./saidas-rpt/saidas-rpt.component";
import { ProdutoDlgModule } from "../produto/produto-dlg.module";
import { RelatorioEntradaConsolidadasRptComponent } from "./entradas-consolidadas-rpt/entradas-consolidadas-rpt.component";

const relatoriosAlmoxarifado = [RelatorioEntradaConsolidadasRptComponent, RelatorioPosicaoEstoqueRptComponent, RelatorioSaidaRptComponent, RelatorioItensMovimentadosRptComponent];

@NgModule({
  declarations: [
    ...relatoriosAlmoxarifado
  ],
  exports: [
    ...relatoriosAlmoxarifado
  ],
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    AutoCompleteModule,
    AccordionModule,
    CalendarModule,
    IMaskModule,
    ToastModule,
    PessoaModule,
    RadioButtonModule,
    FieldsetModule,
    SelectButtonModule,
    DialogModule,
    ButtonModule,
    DragDropModule,
    ToggleButtonModule,
    ConfirmDialogModule,
    CheckboxModule,
    FileUploadModule,
    TooltipModule,
    PanelModule,
    InputMaskModule,
    MenuModule,
    ProdutoDlgModule,
  ],
  providers: [MessageService],
})
export class RelatoriosAlmoxarifadoModule { }
